// 生成从 start 到 end 的数组
export function generateArray(start, end) {
  return Array.from(new Array(end + 1).keys()).slice(start)
}
